/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-shadow */
/* eslint-disable no-underscore-dangle */
import { cloneDeep } from 'lodash';
import React, { useContext } from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useNavigate } from 'react-router-dom';
import ContractConsumptions from '../../components/widgets/ContractConsumptions';
import MonthInvoiceDetails from '../../components/widgets/MonthInvoiceDetails';
import RecentInvoiceDetails from '../../components/widgets/RecentInvoiceDetails';
import TodayDeliveredSchedule from '../../components/widgets/TodayDeliveredSchedule';
import TonnageConsumptions from '../../components/widgets/TonnageConsumptions';
import WidgetDropdown from '../../components/widgets/WidgetDropdown';
import { AppContext } from '../../context/AppContext';
import NButton from '../../components/inputs/NButton';
import useWidgetAPI from '../../hooks/network/useWidgetAPI';
import { errorToaster, successToaster } from '../../components/toaster/Toaster';

const reorder = (list, startIndex, endIndex) => {
  const [removed] = list.splice(startIndex, 1);
  list.splice(endIndex, 0, removed);

  return list;
};

function WidgetSettings() {
  const { setWidgetSettings, widgetSettings } = useContext(AppContext);
  const { saveWidget } = useWidgetAPI();
  const navigate = useNavigate();

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const isDropIn1 = result?.destination?.droppableId === 'droppable-1';
    const isDropIn2 = result?.destination?.droppableId === 'droppable-2';

    let list = [];
    if (isDropIn1) list = widgetSettings?.unSelected;
    if (isDropIn2) list = widgetSettings?.selected;

    const clonedSettings = cloneDeep(widgetSettings);

    if (result?.destination?.droppableId === result?.source?.droppableId) {
      const reorderResult = reorder(list, result.source.index, result.destination.index);
      if (isDropIn1) {
        clonedSettings.unSelected = reorderResult;
      }
      if (isDropIn2) {
        clonedSettings.selected = reorderResult;
      }
    }
    setWidgetSettings(clonedSettings);
  };

  const handleRemoveWidget = (widgetName, index) => {
    const clonedSettings = cloneDeep(widgetSettings);

    clonedSettings?.selected?.splice(index, 1);
    setWidgetSettings(clonedSettings);
  };

  const handleAddWidget = (widgetName, index) => {
    const cs = cloneDeep(widgetSettings);
    const count = cs?.selected?.filter((w) => w?.name === widgetName)?.length;

    if (count > 10) {
      errorToaster('Max Selection Limit reached for the widget');
      return;
    }

    const widgetToAdd = cs?.unSelected?.find((w) => w?.name === widgetName);
    if (!widgetToAdd?.customerId) {
      errorToaster('Please Select Customer And Project');
      return;
    }
    if (!widgetToAdd?.projectId) {
      errorToaster('Please Select Project');
      return;
    }
    cs?.selected?.push(cloneDeep(widgetToAdd));

    setWidgetSettings(cs);
  };

  const renderWidget = (WidgetName, customerId, projectId, isSelected, widgetIndex) => {
    switch (WidgetName) {
      case 'MonthInvoiceDetails':
        return (
          <MonthInvoiceDetails
            isSelectedWidget={isSelected}
            customerId={customerId}
            projectId={projectId}
            widgetIndex={widgetIndex}
          />
        );
      case 'RecentInvoiceDetails':
        return (
          <RecentInvoiceDetails
            isSelectedWidget={isSelected}
            customerId={customerId}
            projectId={projectId}
            widgetIndex={widgetIndex}
          />
        );
      case 'ContractConsumptions':
        return (
          <ContractConsumptions
            isSelectedWidget={isSelected}
            customerId={customerId}
            projectId={projectId}
            widgetIndex={widgetIndex}
          />
        );
      case 'TodayDeliveredSchedule':
        return (
          <TodayDeliveredSchedule
            isSelectedWidget={isSelected}
            customerId={customerId}
            projectId={projectId}
            widgetIndex={widgetIndex}
          />
        );
      case 'TonnageConsumptions':
        return (
          <TonnageConsumptions
            isSelectedWidget={isSelected}
            customerId={customerId}
            projectId={projectId}
            widgetIndex={widgetIndex}
          />
        );
      default:
        return null;
    }
  };

  const handleSaveWidget = async () => {
    try {
      const payload = {
        group: 'widgetSettings',
        key: 'selectedWidgets',
        value: JSON.stringify(widgetSettings?.selected),
      };
      const res = await saveWidget(payload);
      if (res?.success) {
        successToaster('Settings Saved');
        navigate('/');
      }
    } catch {}
  };

  return (
    <div className='flex flex-col gap-8 break:flex-row break:gap-4'>
      <div className='break:h-[calc(100vh-85px)] break:w-1/2 break:overflow-auto breakMax:rounded-lg breakMax:bg-white breakMax:shadow-xl'>
        <div className='mb-2 mt-4 text-center text-xl font-semibold text-gray-900'>
          Personalize your widgets
        </div>
        <div className='mb-2 mt-4 text-center text-sm font-semibold text-gray-900'>
          {`Select your Project and click on the '+' icon to add your widget on to the right pane. Your
          widgets on your right pane will show on your dashboard.`}
        </div>
        {widgetSettings?.unSelected?.map((us, i) => (
          <div key={i} className='mb-6 rounded-lg px-2 break:mb-0 break:p-4'>
            <div className='relative rounded-tl-lg rounded-tr-lg border border-solid border-nblue bg-blue-300 px-4 py-2 breakMax:mb-0.5'>
              <div
                onClick={(e) => {
                  e.preventDefault();
                  handleAddWidget(us?.name, i);
                }}
                className='cursor-pointer'
              >
                <AddCircleIcon className='absolute -top-1.5 -right-1.5 z-10 rounded-full text-green-400 break:-top-3 break:-right-3 break:text-[38px]' />
              </div>
              <WidgetDropdown widgetIndex={i} scope={us?.name} isSelected={false} />
            </div>
            <div className='shadow-lg break:bg-white'>
              <div>{renderWidget(us?.name, us?.customerId, us?.projectId, false, i)}</div>
            </div>
          </div>
        ))}
      </div>

      <div className='relative w-full break:w-1/2'>
        <div className='h-full w-full rounded-lg bg-white pb-14 break:h-[calc(100vh-85px)] break:overflow-auto'>
          {widgetSettings?.selected?.length === 0 && (
            <div className='flex h-full items-center justify-center text-xl breakMax:hidden'>
              Drop your widgets !
            </div>
          )}
          <div className='mb-2 pt-4 text-center text-sm font-medium text-gray-900 break:hidden'>
            Selected Widgets
          </div>
          <div className=''>
            {widgetSettings?.selected?.map((s, i) => (
              <div key={s?.projectId} className='my-6 mb-4 select-none px-2 break:my-4 break:p-4'>
                <div className='relative rounded-lg bg-white'>
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      handleRemoveWidget(s?.name, i);
                    }}
                    className='cursor-pointer'
                  >
                    <CancelIcon className='absolute -top-1.5 -right-1.5 z-10 rounded-full text-red-700 break:-top-4 break:-right-4 break:text-[38px]' />
                  </div>
                  <div>{renderWidget(s?.name, s?.customerId, s?.projectId, true, i)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className='absolute bottom-4 left-1/2 right-1/2 mt-5 flex items-center justify-center'>
          <div className='flex-shrink-0'>
            <NButton variant='Ncontained' onClick={() => handleSaveWidget()}>
              Save Preference
            </NButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WidgetSettings;
